import ftl from "refractor/ftl";
export default ftl;